/**
 * Mocked related articles data for preview/mocked flows.
 * Used when in mocked mode to show pre-populated related articles.
 */

import type { SearchArticle } from '@/common/api/models.pleased';

/**
 * Create mocked related articles data with realistic content
 */
export const createMockedRelatedArticles = (): SearchArticle[] => [
  {
    id: 124,
    brandId: 1,
    sectionId: 1,
    categoryId: 2,
    categoryName: 'Account & Security',
    categoryNameTranslated: 'Account & Security',
    title: 'How to Enable Two-Factor Authentication',
    titleTranslated: 'How to Enable Two-Factor Authentication',
    position: 1,
    isDraft: false,
    isPromoted: true,
    isActive: true,
    language: 'en',
    englishVersion: true,
    updatedAt: new Date().toISOString(),
  },
  {
    id: 125,
    brandId: 1,
    sectionId: 1,
    categoryId: 2,
    categoryName: 'Account & Security',
    categoryNameTranslated: 'Account & Security',
    title: 'Understanding Account Security Settings',
    titleTranslated: 'Understanding Account Security Settings',
    position: 2,
    isDraft: false,
    isPromoted: false,
    isActive: true,
    language: 'en',
    englishVersion: true,
    updatedAt: new Date().toISOString(),
  },
  {
    id: 126,
    brandId: 1,
    sectionId: 1,
    categoryId: 2,
    categoryName: 'Account & Security',
    categoryNameTranslated: 'Account & Security',
    title: 'What to Do If Your Account Is Locked',
    titleTranslated: 'What to Do If Your Account Is Locked',
    position: 3,
    isDraft: false,
    isPromoted: false,
    isActive: true,
    language: 'en',
    englishVersion: true,
    updatedAt: new Date().toISOString(),
  },
  {
    id: 127,
    brandId: 1,
    sectionId: 1,
    categoryId: 2,
    categoryName: 'Account & Security',
    categoryNameTranslated: 'Account & Security',
    title: 'Managing Your Email Preferences',
    titleTranslated: 'Managing Your Email Preferences',
    position: 4,
    isDraft: false,
    isPromoted: false,
    isActive: true,
    language: 'en',
    englishVersion: true,
    updatedAt: new Date().toISOString(),
  },
];
